import { Result, failure, success } from '../shared'
import { AccountAddProvider, AccountSearchProvider, AccountViewProvider } from './providers'
import {
  AccountFailure,
  AccountSearchPages,
  AccountViewPages,
  AccountAddActions,
  AccountOperActions,
} from './models/account.types'
import {
  AccountAddParams,
  AccountOperParams,
  AccountSearchParams,
  AccountViewParams,
  AccountSearchParamsPost,
} from './models'
import { AccountOperProvider } from './providers/oper.provider'

export class AccountService {
  constructor(
    private readonly searchProvider: AccountSearchProvider,
    private readonly viewProvider: AccountViewProvider,
    private readonly addProvider: AccountAddProvider,
    private readonly operProvider: AccountOperProvider,
  ) {}

  public async oper(
    action: AccountOperActions,
    params: Partial<AccountOperParams>,
  ): Promise<Result<any, AccountFailure>> {
    try {
      const { data } = await this.operProvider.oper(action, params)
      return success(data)
    } catch (error) {
      const code = error.Code
      return failure(code, {
        code,
        message: error.Message || error.Text,
      })
    }
  }

  public async add(action: AccountAddActions, params: Partial<AccountAddParams>): Promise<Result<any, AccountFailure>> {
    try {
      const { data } = await this.addProvider.add(action, params)
      return success(data)
    } catch (error) {
      const code = error.Code
      return failure(code, {
        code,
        message: error.Message || error.Text,
      })
    }
  }

  public async search(
    page: AccountSearchPages,
    params: Partial<AccountSearchParams>,
  ): Promise<Result<any, AccountFailure>> {
    try {
      const { data } = await this.searchProvider.search(page, params)
      return success(data)
    } catch (error) {
      const code = error.Code
      return failure(code, {
        code,
        message: error.Message || error.Text,
      })
    }
  }

  public async searchPost(
    page: AccountSearchPages,
    params: Partial<AccountSearchParamsPost>,
  ): Promise<Result<any, AccountFailure>> {
    try {
      const { data } = await this.searchProvider.searchPost(page, params)
      return success(data)
    } catch (error) {
      const code = error.Code
      return failure(code, {
        code,
        message: error.Message || error.Text,
      })
    }
  }

  public async view(page: AccountViewPages, params: Partial<AccountViewParams>): Promise<Result<any, AccountFailure>> {
    try {
      const { data } = await this.viewProvider.view(page, params)
      return success(data)
    } catch (error) {
      const code = error.Code
      return failure(code, {
        code,
        message: error.Message || error.Text,
      })
    }
  }
}
